<div class="email-login-wrapper">
  <i2g-form-master *ngIf="form" class="form" [form]="form">
    <i2g-input-field
      class="form-row"
      e2eId="email-address"
      fieldId="emailAddress"
      layoutDirection="column"
      [fieldControl]="emailAddress"
      [label]="'FORM.EMAIL_ADDRESS.LABEL' | translate"
    >
    </i2g-input-field>

    <i2g-input-field
      class="form-row"
      type="password"
      e2eId="password"
      fieldId="password"
      layoutDirection="column"
      [fieldControl]="password"
      [errorMessages]="passwordErrorMessage"
      [label]="'FORM.PASSWORD.LABEL' | translate"
    >
    </i2g-input-field>
    <i2g-router-link
      [route]="forgotPasswordRoute.route"
      [label]="forgotPasswordRoute.label"
      [alignment]="alignmentEnum.right"
      [trackingObject]="trackingObject"
      [trackingAction]="forgotPasswordRoute.trackingAction"
      [trackingAdditionalProperties]="trackingAdditionalProperties"
      [tabIndex]="-1"
      class="forgot-password"
      e2eId="forgot-password"
    >
    </i2g-router-link>

    <button
      class="login-action"
      e2eId="login-action"
      i2gButton
      buttonStyle="emphasis"
      [disabled]="processing"
      i2gTrackable
      [trackingObject]="trackingObject"
      [trackingAction]="trackingAction"
      [trackingAdditionalProperties]="trackingAdditionalProperties"
      (click)="submit()"
    >
      <i2g-icon *ngIf="processing" class="loading-icon" [icon]="spinnerIcon">
      </i2g-icon>
      {{ (processing ? 'LOGIN.JUST_A_MOMENT' : 'ACTION.LOG_IN') | translate }}
    </button>
  </i2g-form-master>
</div>
